import { logger } from "@/helpers/tslog";
import Control = Office.Control;
import Group = Office.Group;
import Tab = Office.Tab;
import RibbonUpdaterData = Office.RibbonUpdaterData;

export const updateButtonStatus = async (value: boolean) => {
  const button: Control = { id: "contentIsReady", enabled: value };
  const parentGroup: Group = { id: "manageContent", controls: [button] };
  const parentTab: Tab = { id: "AlphaScriptTab", groups: [parentGroup] };
  const ribbonUpdater: RibbonUpdaterData = { tabs: [parentTab] };

  try {
    await Office.ribbon.requestUpdate(ribbonUpdater);
  } catch (error) {
    logger.info("Error updating ribbon:", error);
  }
};
